import type { PropsWithChildren } from 'react';

export interface PropertyListRootProps extends PropsWithChildren {}

export function PropertyListRoot({ children }: PropertyListRootProps) {
  return <dl className="flex flex-col gap-md">{children}</dl>;
}
PropertyListRoot.displayName = 'PropertyListRoot';
